const criteria = [
  { icon: 'ri-checkbox-circle-fill', text: 'Private, regulation-standard padel court' },
  { icon: 'ri-checkbox-circle-fill', text: 'Heated pool or premium outdoor living space' },
  { icon: 'ri-checkbox-circle-fill', text: 'Mediterranean, coastal, or sought-after rural setting' },
  { icon: 'ri-checkbox-circle-fill', text: 'Professional or managed property operation' },
  { icon: 'ri-checkbox-circle-fill', text: 'High-quality photography available or obtainable' },
  { icon: 'ri-checkbox-circle-fill', text: 'Consistent 5-star guest reviews or equivalent' },
];

export default function IdealVilla() {
  return (
    <section id="ideal-villa" className="py-0 overflow-hidden">
      <div className="grid lg:grid-cols-2 min-h-[680px]">
        {/* Left: Image Grid */}
        <div className="relative grid grid-rows-2 h-[500px] lg:h-auto">
          <div className="relative overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/f047d58545bbda0291e313d603fd23d4.jpg"
              alt="Luxury villa exterior"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="grid grid-cols-2">
            <div className="overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_8bf91d32770107392df7c3a666773eb5_53629502.jpg"
                alt="Private padel court"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=luxury%20villa%20outdoor%20terrace%20dining%20sea%20view%20mediterranean%20cuisine%20elegant%20table%20setting%20sunset%20alfresco%20olive%20trees%20elegant%20high-end&width=400&height=300&seq=ideal3&orientation=landscape"
                alt="Luxury villa terrace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Right: Content */}
        <div className="bg-[#2C2C2C] flex items-center px-12 lg:px-16 py-16">
          <div className="max-w-lg">
            <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
              Ideal Villa Profile
            </p>
            <h2 className="font-cormorant text-4xl lg:text-5xl font-light text-white leading-[1.1] mb-4">
              Is Your Villa<br />
              <em className="italic text-[#C9A86A]">a Perfect Match?</em>
            </h2>
            <p className="font-inter font-light text-white/60 text-sm mb-10 leading-relaxed">
              We curate only the finest properties. If your villa meets these criteria, we want to hear from you.
            </p>

            {/* Checklist */}
            <ul className="space-y-4 mb-10">
              {criteria.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#D4845C] text-base`} />
                  </div>
                  <span className="font-inter font-light text-white/80 text-sm leading-snug">{item.text}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => {
                const el = document.getElementById('lead-form');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="whitespace-nowrap border border-white/30 text-white font-inter font-medium text-sm px-7 py-3.5 rounded-full hover:bg-white/10 transition-colors duration-200 cursor-pointer inline-flex items-center gap-2"
            >
              Check Eligibility &amp; Register
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
